import React, { useState } from "react";
import AddEditBooking from "../../../Components/AddEditBooking/AddEditBooking";
import {
  useAddPaymentMutation,
  useOrderByIdQuery,
  usePaymentByIdQuery,
  useUpdateReservationMutation,
} from "../../../Store/Apis/bookingApi";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { SimpleReservationUpdateHandler } from "../../../Utils/SimpleReservationUpdateHandler";
import { resendBookingEmail } from "../../../Store/Apis/ReservationApi";

const EditBooking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("id");
  const user = useSelector((state) => state.auth.user);
  const outletID = user?.outletID || user?.outletId || 0;
  const orderByIdApi = useOrderByIdQuery({
    orderID: orderId,
    outletID: outletID,
  });

  const paymentByIdApi = usePaymentByIdQuery({
    orderId: orderId,
  });

  console.log("orderByIdApi data:", orderByIdApi.data);

  const [addPaymentMutation] = useAddPaymentMutation();
  const [updateReservation, { isLoading: isUpdating }] =
    useUpdateReservationMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (formData, options = {}) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      console.log("=== SIMPLE UPDATE FLOW ===");
      console.log("Original formData:", formData);

      // Create the simple update handler - no complex logic, just format the data
      const updateHandler = new SimpleReservationUpdateHandler(
        orderByIdApi,
        paymentByIdApi,
      );

      // Process the update - direct formatting
      const updateResult = updateHandler.processUpdate(formData);

      if (!updateResult.success) {
        throw new Error(updateResult.error);
      }

      // Log debug information
      updateHandler.logDebugInfo();

      const payload = updateResult.payload;

      console.log("=== CALLING UPDATE RESERVATION API ===");
      console.log("Payload being sent:", payload);

      // Use RTK Query mutation instead of plain fetch
      const result = await updateReservation(payload).unwrap();

      console.log("=== UPDATE RESERVATION RESPONSE ===");
      console.log("Response:", result);
      console.log("✅ Reservation updated successfully");

      toast.success(result?.message || "Reservation updated successfully", {
        duration: 3000,
      });

      if (options?.sendResendAfterSave && options?.resendDocument) {
        console.log(
          "Resend request triggered from edit save flow",
          options.resendDocument,
        );
        const orderRecord = orderByIdApi?.data?.data?.[0] || {};
        const resendResult = await resendBookingEmail({
          outletId: outletID,
          orderId: orderId,
          documentType:
            options.resendDocument?.documentType ||
            orderRecord.bookingType ||
            orderRecord.BookingType ||
            "Proforma",
        });

        if (resendResult?.success) {
          toast.success(
            resendResult?.message || "Resend request sent successfully.",
            { duration: 4000 },
          );
        } else {
          toast.error(resendResult?.message || "Failed to resend document.", {
            duration: 7000,
          });
        }
      }

      // Navigate to sales history after successful update
      navigate("/sales-history");

      console.log("Navigating to sales history");
      return result;
    } catch (error) {
      console.error("❌ Update reservation failed:");
      console.error("Error object:", error);

      const errorMessage =
        error?.data?.message ||
        error?.message ||
        "Failed to update reservation";

      toast.error(errorMessage, { duration: 7000 });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResendDocument = async (payload) => {
    console.log("Resend document requested:", payload);

    try {
      const orderRecord = orderByIdApi?.data?.data?.[0] || {};
      const result = await resendBookingEmail({
        outletId: payload?.outletId || outletID,
        orderId: payload?.orderId || orderId,
        documentType:
          payload?.documentType ||
          orderRecord.bookingType ||
          orderRecord.BookingType ||
          "Proforma",
      });

      if (result?.success) {
        toast.success(
          result?.message ||
            `Resend requested for order ${payload.orderNumber || payload.orderId}.`,
          { duration: 4000 },
        );
      } else {
        toast.error(result?.message || "Failed to resend document.", {
          duration: 7000,
        });
      }
    } catch (error) {
      console.error("Resend document failed:", error);
      toast.error("Failed to resend document.", { duration: 7000 });
    }
  };

  return (
    <div>
      {/* DEBUG: Show API status */}
      {/* <div style={{padding: '10px', background: '#f0f0f0', margin: '10px', fontSize: '12px'}}>
        <strong>DEBUG INFO:</strong><br/>
        Order API - Loading: {orderByIdApi.isLoading ? 'YES' : 'NO'}, 
        Success: {orderByIdApi.isSuccess ? 'YES' : 'NO'}, 
        Error: {orderByIdApi.isError ? 'YES' : 'NO'}<br/>
        Payment API - Loading: {paymentByIdApi.isLoading ? 'YES' : 'NO'}, 
        Success: {paymentByIdApi.isSuccess ? 'YES' : 'NO'}, 
        Error: {paymentByIdApi.isError ? 'YES' : 'NO'}<br/>
        Order ID: {orderId}<br/>
        Outlet ID: {outletID}<br/>
        {orderByIdApi.isError && <div style={{color: 'red'}}>Order API Error: {JSON.stringify(orderByIdApi.error)}</div>}
        {paymentByIdApi.isError && <div style={{color: 'red'}}>Payment API Error: {JSON.stringify(paymentByIdApi.error)}</div>}
      </div> */}

      {orderByIdApi.isSuccess && paymentByIdApi.isSuccess && (
        <AddEditBooking
          data={orderByIdApi?.data?.data[0]}
          paymentData={{
            discountType: orderByIdApi?.data?.data[0].discountType,
            discount: orderByIdApi?.data?.data[0].discount,
            paidAmount: orderByIdApi?.data?.data[0].amountPaid,
            paymentType: paymentByIdApi?.data?.data[0].paymentType,
            utrNumber: paymentByIdApi?.data?.data[0].utrNumber,
            notes: paymentByIdApi?.data?.data[0].notes,
            specialInstruction: "",
          }}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onResendDocument={handleResendDocument}
        />
      )}
    </div>
  );
};

export default EditBooking;
